import FacebookIcon from 'assets/facebook.svg';
import LinkedInIcon from 'assets/linkedin-link.svg';
import TwitterIcon from 'assets/x.svg';

export const IconMap = {
  TWITTER: TwitterIcon,
  FACEBOOK: FacebookIcon,
  LINKED_IN: LinkedInIcon,
};
